<template>
  <div class="users-container">
    <div class="user-toolbar">
      <el-button type="primary" @click="openUserDialog">新增用户</el-button>
    </div>
    <el-table :data="userList" border style="width: 100%">
      <el-table-column prop="username" label="用户名" />
      <el-table-column prop="role" label="角色">
        <template slot-scope="scope">
          <el-tag :type="scope.row.role === 'admin' ? 'danger' : 'info'">
            {{ scope.row.role === 'admin' ? '管理员' : '操作员' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="创建时间" />
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.username !== 'admin'"
            type="text"
            style="color: #F56C6C"
            @click="handleDeleteUser(scope.row.id)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="新增用户" :visible.sync="userDialogVisible" width="400px">
      <el-form label-width="80px">
        <el-form-item label="用户名">
          <el-input v-model="userForm.username" />
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="userForm.password" type="password" />
        </el-form-item>
        <el-form-item label="角色">
          <el-select v-model="userForm.role" style="width: 100%">
            <el-option label="管理员" value="admin" />
            <el-option label="操作员" value="operator" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="userDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleCreateUser">确定提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUsers, createUser, deleteUser } from "@/net/api";

const defaultUserForm = () => ({
  username: "",
  password: "",
  role: "operator"
});

export default {
  name: "Users",
  data() {
    return {
      userList: [],
      userDialogVisible: false,
      userForm: defaultUserForm()
    };
  },
  created() {
    this.loadUsers();
  },
  methods: {
    async loadUsers() {
      try {
        const { data } = await getUsers();
        this.userList = data;
      } catch (error) {
        console.error("加载用户列表失败", error);
      }
    },
    openUserDialog() {
      this.userForm = defaultUserForm();
      this.userDialogVisible = true;
    },
    async handleCreateUser() {
      if (!this.userForm.username || !this.userForm.password) {
        this.$message.warning("请填写完整信息");
        return;
      }
      try {
        await createUser(this.userForm);
        this.$message.success("用户创建成功");
        this.userDialogVisible = false;
        this.loadUsers();
      } catch (error) {
        this.$message.error(error.response?.data?.message || "创建失败");
      }
    },
    async handleDeleteUser(userId) {
      try {
        await this.$confirm("确定删除该用户吗？", "提示", { type: "warning" });
        await deleteUser(userId);
        this.$message.success("删除成功");
        this.loadUsers();
      } catch (error) {
        if (error !== "cancel") {
          this.$message.error(error.response?.data?.message || "删除失败");
        }
      }
    }
  }
};
</script>

<style scoped>
.user-toolbar {
  margin-bottom: 20px;
}
</style>
